/**
 * A seção de cookies da política. Um `<a>` comum, não um `<Link>`: o aviso monta
 * fora do router (vale para todas as rotas), e a política é um destino raro o
 * bastante para uma navegação completa.
 */
export const COOKIE_POLICY_HREF = '/privacidade#cookies';
